// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__qhheM","resendInfoText":"OnGoingPaymentBox_resendInfoText__5ZJVW"};